import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SetupDataChannel, SetupDataTeam } from 'voxloud-types/dist/models';

export interface SelectTeamOutput {
  TEAM_ID: string;
  TEAMS_CHANNEL_ID: string;
}

@Component({
  selector: 'gdp-integration-select-team',
  templateUrl: './integration-select-team.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: IntegrationSelectTeamComponent
    }
  ]
})
export class IntegrationSelectTeamComponent implements ControlValueAccessor {

  @Input() loading: boolean = false;
  @Input() setupDataTeam: SetupDataTeam[];

  private onChange: (_) => void;
  private onTouched: (_) => void;
  public disabled: boolean = false;

  public selectedTeam: SetupDataTeam;
  public selectedChannel: SetupDataChannel;

  public selectTeam(team: SetupDataTeam): void {
    if(this.selectedTeam?.id === team.id) return;
    this.selectedTeam = team;
    this.selectedChannel = null;
    this.formatAndSend();
  }

  public selectChannel(channel: SetupDataChannel): void {
    if(this.selectedChannel?.id === channel.id) return;
    this.selectedChannel = channel;
    this.formatAndSend();
  }

  private findTeam(teamId: string): SetupDataTeam{
    return this.setupDataTeam?.find((sdt: SetupDataTeam) => {
      return sdt.id === teamId;
    });
  }

  private findChannel(channelId: string): SetupDataChannel {
    return this.selectedTeam?.channels.find((sdc: SetupDataChannel) => {
      return sdc.id === channelId;
    });
  }

  private formatAndSend(): void {
    let output: SelectTeamOutput = null;
    if(this.selectedTeam && this.selectedChannel) {
      output = {
        TEAM_ID: this.selectedTeam.id,
        TEAMS_CHANNEL_ID: this.selectedChannel.id
      }
    }
    if(this.onChange) this.onChange(output);
  }

  writeValue(obj: any): void {
    if(obj && obj.TEAM_ID) {
      this.selectedTeam = this.findTeam(obj.TEAM_ID);
      this.selectedChannel = this.findChannel(obj.TEAMS_CHANNEL_ID);
    }
    this.formatAndSend();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.formatAndSend();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
